/**
 * Coupon Mutations
 *
 * Mutation hooks for coupon-related operations.
 * Business logic is 100% identical to mobile module-flash-sale.
 *
 * @module @kidslabs/module-flash-sale/api/mutations/coupon.mutation
 */

import { useValidateCouponsMutation, type ValidateCouponsMutationVariables } from '../../types/front.graphql';

/**
 * Hook for validating coupons
 *
 * Validates coupon codes against the cart.
 *
 * @param variables - Optional variables for validation
 */
export const useValidateCoupons = (variables?: ValidateCouponsMutationVariables) => {
    const [validateCoupons, { data, loading, error }] = useValidateCouponsMutation({
        fetchPolicy: 'no-cache',
        variables,
    });

    const dataValidatedCoupons = data?.validateCoupons ?? null;

    return {
        validateCoupons,
        dataValidatedCoupons,
        loading,
        error,
    };
};
